import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Layout from "../homeDashboard/HomeDashboardLayout";
import HomeDashboardLayout from "../homeDashboard/HomeDashboardLayout";
import HeaderProfileSection from "../homeDashboard/HeaderProfileSection";
import "../dashboard/Dashboard.css";
import PwdImg from "../assets/images/lock-pwd.png";
import { changePassword } from "../services/authService";

//Import SVg
import { BackSVG } from "../components/SvgIcons";
import MyWalletSidebar from "../homeDashboard/MyWalletSidebar";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [submitError, setSubmitError] = useState("");
  const [submitSuccess, setSubmitSuccess] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPasswords, setShowPasswords] = useState({
    currentPassword: false,
    newPassword: false,
    confirmNewPassword: false,
  });

  const validateForm = () => {
    const nextErrors = {};

    if (!formValues.currentPassword) {
      nextErrors.currentPassword = "Current password is required.";
    }

    if (!formValues.newPassword) {
      nextErrors.newPassword = "New password is required.";
    } else if (formValues.newPassword.length < 6) {
      nextErrors.newPassword = "Password must be at least 6 characters.";
    } else if (formValues.newPassword === formValues.currentPassword) {
      nextErrors.newPassword =
        "The new password must be different from the current password.";
    } else if (
      !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@!$#%]).{6,}$/.test(formValues.newPassword)
    ) {
      nextErrors.newPassword =
        "Password must include a letter, a number, and a special character (@!$#%).";
    }

    if (!formValues.confirmNewPassword) {
      nextErrors.confirmNewPassword = "Confirm new password is required.";
    } else if (formValues.confirmNewPassword !== formValues.newPassword) {
      nextErrors.confirmNewPassword =
        "Confirm new password must match the new password.";
    }

    setFieldErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormValues((currentValues) => ({
      ...currentValues,
      [name]: value,
    }));
    setFieldErrors((currentErrors) => ({
      ...currentErrors,
      [name]: "",
    }));
    setSubmitError("");
    setSubmitSuccess("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitError("");
    setSubmitSuccess("");

    try {
      const { meta } = await changePassword({
        current_password: formValues.currentPassword,
        new_password: formValues.newPassword,
        confirm_new_password: formValues.confirmNewPassword,
      });

      setSubmitSuccess(meta?.message || "Password changed successfully.");
      setFormValues({
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      });
      setFieldErrors({});
    } catch (error) {
      setSubmitError(error.message || "Unable to change password right now.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const togglePasswordVisibility = (fieldName) => {
    setShowPasswords((currentState) => ({
      ...currentState,
      [fieldName]: !currentState[fieldName],
    }));
  };

  return (
    <>
      <style>{`
        .page-content {
          background: linear-gradient(180deg, #f7f4ff 0%, #ffffff 22%);
        }

        body {
          background: #f7f4ff !important;
        }

        .change-pwd {
          // min-height: calc(100vh - 40px);
          padding: 32px 0px 48px;
        }

        .change-pwd__card {
          // width: min(100%, 760px);
          padding: 36px 40px 40px;
          border-radius: 32px;
          background:transparent;
          // border: 1px solid rgba(103, 78, 221, 0.12);
          // box-shadow: 0 22px 60px rgba(64, 37, 143, 0.10);
          // backdrop-filter: blur(10px);
        }

        .change-pwd__media {
          width: 116px;
          height: 116px;
          margin: 0 auto 14px;
          display: grid;
          place-items: center;
          border-radius: 28px;
          background: linear-gradient(180deg, rgba(103, 78, 221, 0.10) 0%, rgba(255, 255, 255, 0.9) 100%);
        }

        .change-pwd__media img {
          width: 84px;
          height: auto;
        }

        .change-pwd__title {
          margin: 0 0 8px;
          text-align: center;
          font-size: 2rem;
          font-weight: 800;
          line-height: 1.1;
        }

        .change-pwd__subtitle {
          max-width: 480px;
          margin: 0 auto 24px;
          text-align: center;
          color: #756f8f;
          font-size: 0.98rem;
          line-height: 1.6;
        }

        .change-pwd__alert {
          border-radius: 18px;
          padding: 14px 16px;
          font-size: 0.95rem;
        }

        .change-pwd__form {
          display: flex;
          flex-direction: column;
          gap: 18px;
        }

        .change-pwd__field {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .change-pwd__label {
          margin: 0;
          color: #171327;
          font-size: 1rem;
          font-weight: 700;
        }

        .change-pwd__inputWrap {
          position: relative;
        }

        .change-pwd__input {
          width: 100%;
          min-height: 58px;
          padding: 16px 56px 16px 18px;
          border-radius: 18px;
          border: 1.5px solid #d9d0ff;
          background: #fff;
          color: #18142a;
          font-size: 1rem;
          outline: none;
          transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
        }

        .change-pwd__input::placeholder {
          color: #8f89a6;
        }

        .change-pwd__input:focus {
          border-color: #7b5cff;
          box-shadow: 0 0 0 4px rgba(123, 92, 255, 0.12);
        }

        .change-pwd__input[aria-invalid="true"] {
          border-color: #ef6b6b;
          background: #fffafa;
        }

        .change-pwd__toggle {
          position: absolute;
          top: 50%;
          right: 12px;
          width: 34px;
          height: 34px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: 0;
          border-radius: 12px;
          background: transparent;
          color: #5a5472;
          transform: translateY(-50%);
          transition: background-color 0.2s ease, color 0.2s ease;
        }

        .change-pwd__toggle:hover,
        .change-pwd__toggle:focus-visible {
          background: #f2eeff;
          color: #4d1fe0;
          outline: none;
        }

        .change-pwd__error {
          color: #d94c4c;
          font-size: 0.88rem;
          font-weight: 600;
          line-height: 1.4;
          margin-top: -2px;
        }

        .change-pwd__submit {
          min-width: 220px;
          min-height: 54px;
          margin-top: 6px;
          padding: 0 26px;
          border: 0;
          border-radius: 18px;
          font-size: 1rem;
          font-weight: 800;
          color: #fff;
          box-shadow: 0 18px 30px rgba(103, 78, 221, 0.22);
        }

        .change-pwd__submit:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        @media (max-width: 767px) {
          .headerDash {
            display: none;
          }

          .layout-wrapper .main-content {
            padding-top: 0px !important;
          }

          .change-pwd {
            padding: 18px 12px 28px;
            align-items: flex-start !important;
          }

          .change-pwd__card {
            padding: 24px 18px 26px;
            border-radius: 24px;
          }

          .change-pwd__media {
            width: 92px;
            height: 92px;
            border-radius: 22px;
            margin-bottom: 12px;
          }

          .change-pwd__media img {
            width: 68px;
          }

          .change-pwd__title {
            font-size: 1.7rem;
          }

          .change-pwd__subtitle {
            font-size: 0.9rem;
            margin-bottom: 20px;
          }

          .change-pwd__input {
            min-height: 54px;
            padding: 14px 52px 14px 16px;
            border-radius: 16px;
          }

          .change-pwd__submit {
            width: 100%;
            min-width: 0;
          }
        }

        .change-pwd {
            margin-top: 0;
            // min-height: calc(100vh - 80px);
            padding: 40px 0px 72px;
            // background: #faf9ff;
            position: relative;
        }

        .change-pwd__card {
            // width: min(100%, 980px);
            display: grid;
            grid-template-columns: minmax(280px, 0.9fr) minmax(0, 1.35fr);
            padding: 0;
           // border-radius: 28px;
           // border: 1px solid #e9e5f6;
           // background: #fff;
           // box-shadow: 0 18px 46px rgba(61, 44, 120, 0.08);
           height: calc(100vh - 300px);
        }
        .change-pwd__card::after {
           content: "";
           position: absolute;
           top: 0;
           bottom: 0;
           left: 40%;
           width: 1px;
           background: #ddd;
         }
        //.change-pwd__card > :nth-child(2) {
          //border-left: 1px solid #ddd;
        // }
        .change-pwd__intro {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding: 38px 25px 38px 0px;
          // background: linear-gradient(155deg, #f4f1ff 0%, #eae5ff 100%);
        }

        .change-pwd__back {
          width: 40px;
          height: 40px;
          align-items: center;
          justify-content: center;
          margin-bottom: 34px;
          border: 1px solid #dbd3f7;
          border-radius: 12px;
          background: #fff;
          color: #4932b5;
        }

        .change-pwd__media {
          width: 88px;
          height: 88px;
          margin: 0 0 24px;
          border-radius: 24px;
          background: #fff;
          box-shadow: 0 12px 28px rgba(103, 78, 221, 0.10);
        }

        .change-pwd__media img {
          width: 64px;
        }

        .change-pwd__eyebrow {
          margin-bottom: 10px;
          color: #6244d8;
          font-size: 0.8rem;
          font-weight: 800;
          letter-spacing: 0.09em;
          text-transform: uppercase;
        }

        .change-pwd__title {
          margin: 0 0 12px;
          color: #21193f;
          text-align: left;
          font-size: clamp(1.65rem, 2.2vw, 2.2rem);
          line-height: 1.18;
        }

        .change-pwd__subtitle {
          margin: 0 0 30px;
          color: #655d80;
          text-align: left;
          font-size: 0.94rem;
        }

        .change-pwd__tips {
          display: grid;
          gap: 14px;
          // margin-top: auto;
          color: #3b315e;
          font-size: 0.87rem;
          line-height: 1.4;
        }

        .change-pwd__tips span {
          display: flex;
          align-items: flex-start;
          gap: 10px;
        }

        .change-pwd__tips span::before {
          content: '✓';
          display: grid;
          place-items: center;
          flex: 0 0 20px;
          height: 20px;
          border-radius: 50%;
          background: #fff;
          color: #5e42d9;
          font-size: 0.75rem;
          font-weight: 800;
        }

        .change-pwd__form-panel {
          min-width: 0;
          padding: 48px 0 48px 25px;
        }

        .change-pwd__form-title {
          margin: 0 0 6px;
          color: #21193f;
          font-size: 1.45rem;
          font-weight: 750;
        }

        .change-pwd__form-description {
          margin: 0 0 30px;
          color: #79738c;
          font-size: 0.92rem;
        }

        .change-pwd__form {
          gap: 20px;
        }

        .change-pwd__label {
          font-size: 0.91rem;
          font-weight: 700;
        }

        .change-pwd__input {
          min-height: 56px;
          padding: 12px 52px 12px 52px;
          border: 1px solid #ddd8f1;
          border-radius: 999px;
          background: #fbfaff;
          font-size: 0.94rem;
        }

        .change-pwd__inputIcon {
          position: absolute;
          top: 50%;
          left: 16px;
          display: grid;
          place-items: center;
          width: 24px;
          height: 24px;
          transform: translateY(-50%);
          color: #7b71a5;
          pointer-events: none;
        }

        .change-pwd__toggle {
          right: 14px;
          color: #766c99;
          cursor: pointer;
        }

        .change-pwd__submit {
          width: 100%;
          max-width: none;
          min-height: 56px;
          margin-top: 8px;
          border-radius: 999px;
          background: #6043ee;
          box-shadow: none;
        }

        .change-pwd__submit:hover:not(:disabled) {
          background: #5135d5;
        }

        @media (max-width: 992px) {
          

          .change-pwd__intro {
            padding: 26px 0px;
          }

          .change-pwd__back {
            margin-bottom: 20px;
          }

          .change-pwd__media {
            width: 64px;
            height: 64px;
            margin-bottom: 16px;
            border-radius: 18px;
          }

          .change-pwd__media img {
            width: 48px;
          }

          .change-pwd__subtitle {
            margin-bottom: 18px;
          }

          .change-pwd__form-panel {
            padding: 32px 0 32px 32px ;
          }
        }

        @media (max-width: 767px) {
          .change-pwd {
            padding: 16px 0px 36px;
          }

          .change-pwd__card {
            border-radius: 22px;
          }

          .change-pwd__intro {
            padding: 22px 0;
          }
          .change-pwd__card {
            grid-template-columns: 1fr;
          }
          .change-pwd__title {
            font-size: 1.6rem;
          }

          .change-pwd__form-panel {
            padding: 0px 0px 0px;
          }

          .change-pwd__input,
          .change-pwd__submit {
            min-height: 52px;
          }
          .change-pwd__card::after {
           display:none;
         }
        .change-pwd__card {
            height:100vh;
        }
        }
        
        @media (min-width: 1200px) and (max-width: 1400px){
         .change-pwd__card::after {
            left: 50%;
         }
         .change-pwd__intro {
            padding: 38px 15px 38px 0px;
         }
        .page-padding {
           padding: 30px 15px!mportant;
         }
        .change-pwd__form-panel {
            padding: 48px 0 48px 15px;
        }
       .change-pwd__card {
           grid-template-columns: repeat(2, minmax(0, 1fr));
         }
      .change-pwd__subtitle {
         font-size: 14px;
         }
        }
      `}</style>

      <HomeDashboardLayout showHeader={false}>
        {/* <div className="d-flex justify-content-between align-items-center d-md-none header-Mobile">
        <button
          type="button"
          className="languageImg d-flex d-md-none"
          onClick={() => navigate(-1)}
          aria-label="Go back"
          style={{ background: "transparent", border: 0, padding: 0 }}
        >
          <BackSVG />
        </button>

      </div> */}
        <div className="page-padding">
          <div className="hideProfile-page ">
            {/* Page header */}
            <div className="categories-page-header mb-0 ">
              <div>
                <button type="button" className="categories-back-button">
                  <i className="bi bi-chevron-left"></i>
                </button>
              </div>
              <div>
                <h4 className="d-flex categories-page-title"> </h4>
              </div>
              <div>
                <HeaderProfileSection />
              </div>
            </div>
          </div>

          <div className="qb-wrapper change-pwd d-flex align-items-center justify-content-center">
            <div className="change-pwd__card">
              <div className="change-pwd__intro">
                {/* <button type="button" className="change-pwd__back d-none d-md-inline-flex" onClick={() => navigate(-1)} aria-label="Go back">
              <BackSVG />
            </button> */}
                <div className="change-pwd__media">
                  <img src={PwdImg} alt="" />
                </div>
                <span className="change-pwd__eyebrow">Account security</span>
                <h1 className="change-pwd__title">Change your password</h1>
                <p className="change-pwd__subtitle">
                  Choose a password that keeps your Vidya Kasam account secure.
                </p>
                <div className="change-pwd__tips">
                  <span>Use at least 6 characters</span>
                  <span>Include a letter, number and @!$#%</span>
                  <span>Choose a password different from your current one</span>
                </div>
              </div>

              <div className="change-pwd__form-panel">
                <h2 className="change-pwd__form-title">Update password</h2>
                <p className="change-pwd__form-description">
                  Enter your current password, then set a new one.
                </p>

                {submitError ? (
                  <Alert className="mb-3 change-pwd__alert" variant="danger">
                    {submitError}
                  </Alert>
                ) : null}

                {submitSuccess ? (
                  <Alert className="mb-3 change-pwd__alert" variant="success">
                    {submitSuccess}
                  </Alert>
                ) : null}

                <form
                  className="change-pwd__form"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div className="change-pwd__field">
                    <label
                      htmlFor="current-password"
                      className="change-pwd__label"
                    >
                      Current Password
                    </label>
                    <div className="change-pwd__inputWrap">
                      <span
                        className="change-pwd__inputIcon"
                        aria-hidden="true"
                      >
                        <i className="bi bi-lock" />
                      </span>
                      <input
                        id="current-password"
                        type={
                          showPasswords.currentPassword ? "text" : "password"
                        }
                        className="change-pwd__input"
                        placeholder="Current Password"
                        name="currentPassword"
                        value={formValues.currentPassword}
                        onChange={handleChange}
                        autoComplete="current-password"
                        aria-invalid={Boolean(fieldErrors.currentPassword)}
                      />
                      <button
                        type="button"
                        className="change-pwd__toggle"
                        aria-label={
                          showPasswords.currentPassword
                            ? "Hide current password"
                            : "Show current password"
                        }
                        onClick={() =>
                          togglePasswordVisibility("currentPassword")
                        }
                      >
                        <i
                          className={`bi ${showPasswords.currentPassword ? "bi-eye-slash" : "bi-eye"}`}
                        />
                      </button>
                    </div>
                    {fieldErrors.currentPassword ? (
                      <div className="change-pwd__error">
                        {fieldErrors.currentPassword}
                      </div>
                    ) : null}
                  </div>

                  <div className="change-pwd__field">
                    <label htmlFor="new-password" className="change-pwd__label">
                      New Password
                    </label>
                    <div className="change-pwd__inputWrap">
                      <span
                        className="change-pwd__inputIcon"
                        aria-hidden="true"
                      >
                        <i className="bi bi-lock" />
                      </span>
                      <input
                        id="new-password"
                        type={showPasswords.newPassword ? "text" : "password"}
                        className="change-pwd__input"
                        placeholder="Password (A-Z, a-z, 0-9, @!$#%)."
                        name="newPassword"
                        value={formValues.newPassword}
                        onChange={handleChange}
                        autoComplete="new-password"
                        aria-invalid={Boolean(fieldErrors.newPassword)}
                      />
                      <button
                        type="button"
                        className="change-pwd__toggle"
                        aria-label={
                          showPasswords.newPassword
                            ? "Hide new password"
                            : "Show new password"
                        }
                        onClick={() => togglePasswordVisibility("newPassword")}
                      >
                        <i
                          className={`bi ${showPasswords.newPassword ? "bi-eye-slash" : "bi-eye"}`}
                        />
                      </button>
                    </div>
                    {fieldErrors.newPassword ? (
                      <div className="change-pwd__error">
                        {fieldErrors.newPassword}
                      </div>
                    ) : null}
                  </div>

                  <div className="change-pwd__field">
                    <label
                      htmlFor="confirm-password"
                      className="change-pwd__label"
                    >
                      Confirm New Password
                    </label>
                    <div className="change-pwd__inputWrap">
                      <span
                        className="change-pwd__inputIcon"
                        aria-hidden="true"
                      >
                        <i className="bi bi-lock" />
                      </span>
                      <input
                        id="confirm-password"
                        type={
                          showPasswords.confirmNewPassword ? "text" : "password"
                        }
                        className="change-pwd__input"
                        placeholder="Password (A-Z, a-z, 0-9, @!$#%)."
                        name="confirmNewPassword"
                        value={formValues.confirmNewPassword}
                        onChange={handleChange}
                        autoComplete="new-password"
                        aria-invalid={Boolean(fieldErrors.confirmNewPassword)}
                      />
                      <button
                        type="button"
                        className="change-pwd__toggle"
                        aria-label={
                          showPasswords.confirmNewPassword
                            ? "Hide confirm new password"
                            : "Show confirm new password"
                        }
                        onClick={() =>
                          togglePasswordVisibility("confirmNewPassword")
                        }
                      >
                        <i
                          className={`bi ${showPasswords.confirmNewPassword ? "bi-eye-slash" : "bi-eye"}`}
                        />
                      </button>
                    </div>
                    {fieldErrors.confirmNewPassword ? (
                      <div className="change-pwd__error">
                        {fieldErrors.confirmNewPassword}
                      </div>
                    ) : null}
                  </div>

                  <button
                    type="submit"
                    className="change-pwd__submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Updating..." : "Update"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <MyWalletSidebar withTopOffset={false} />
      </HomeDashboardLayout>
    </>
  );
};

export default ChangePassword;
